import authRoles from 'app/auth/authRoles';
import { FuseLoadable } from '@fuse';

export default {
    auth: [...authRoles.admin],
    routes: [{ exact: true, path: '/processed-fluid-commodities', component: FuseLoadable({ loader: () => import('./CommodityApp') }) }],
};
